"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _Autocomplete = _interopRequireDefault(require("../../Autocomplete"));

var _classnames = _interopRequireDefault(require("classnames"));

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _focusRing = require("../../utils/focusRing");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _TagList = require("../../TagList");

var _Textfield = _interopRequireDefault(require("../../Textfield"));

require("../style/index.css");

var _class, _class2, _temp;

var TagField = (0, _convertUnsafeMethod["default"])(_class = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(TagField, _React$Component);

  function TagField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, TagField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TagField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      value: '',
      tags: _this.props.value || [],
      showMenu: false,
      isFocusVisible: false
    });
    return _this;
  }

  (0, _createClass2["default"])(TagField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      var _this2 = this;

      if (props.value && props.value !== this.state.value) {
        var deleting = props.value.length < this.state.tags.length;

        var hadFocus = this.taglist && _reactDom["default"].findDOMNode(this).contains(document.activeElement);

        this.setState({
          tags: props.value
        }, function () {
          return hadFocus && _this2.focus(deleting);
        });
      }
    }
  }, {
    key: "onTextfieldChange",
    value: function onTextfieldChange(value) {
      this.setState({
        value: value
      });
    }
  }, {
    key: "onSelect",
    value: function onSelect(value) {
      var coercedValue = value.label || value;

      var areDuplicates = function areDuplicates(a, b) {
        return a === b || a.label && b.label && a.label === b.label;
      };

      if (!coercedValue || !this.props.allowDuplicates && this.state.tags.some(function (t) {
        return areDuplicates(t, value);
      })) {
        return;
      } // Menu should always hide when item is selected.


      this.setState({
        value: '',
        showMenu: false
      });
      var tags = [].concat((0, _toConsumableArray2["default"])(this.state.tags), [value]);
      this.onChange(tags);
    }
  }, {
    key: "onRemove",
    value: function onRemove(value) {
      var tags = this.state.tags.filter(function (t) {
        return t.label !== value && t !== value;
      });
      this.onChange(tags);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setState({
        isFocusVisible: this.textfield && _reactDom["default"].findDOMNode(this.textfield).classList.contains(_focusRing.FOCUS_RING_CLASSNAME)
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        isFocusVisible: false
      });
    }
  }, {
    key: "focus",
    value: function focus(deleting) {
      if (this.taglist) {
        var dom = _reactDom["default"].findDOMNode(this.taglist);

        if (!dom.contains(document.activeElement)) {
          var nodes = dom.querySelectorAll('[role=row]');

          if (nodes.length && deleting) {
            nodes[nodes.length - 1].focus();
          } else {
            this.textfield.focus();
          }
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(tags) {
      var _this3 = this;

      if (this.props.value == null) {
        var deleting = tags.length < this.state.tags.length;
        this.setState({
          tags: tags
        }, function () {
          return _this3.focus(deleting);
        });
      }

      if (this.props.onChange) {
        this.props.onChange(tags.map(function (tag) {
          return tag.label || tag;
        }));
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this4 = this;

      // Remove the last tag in the list when pressing BACKSPACE in an empty text field
      if (e.key === 'Backspace' && this.state.value === '') {
        e.preventDefault();
        this.setState(function (prevState) {
          if (prevState.tags.length > 0) {
            var tags = prevState.tags.slice(0, -1);

            _this4.onChange(tags);

            return {
              tags: tags
            };
          } else {
            return null;
          }
        });
      }
    }
  }, {
    key: "onMenuToggle",
    value: function onMenuToggle(showMenu) {
      // menu should not be shown when there is no value
      if (showMenu && this.state.value === '') {
        showMenu = false;
      }

      this.setState({
        showMenu: showMenu
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          getCompletions = _this$props.getCompletions,
          allowCreate = _this$props.allowCreate,
          disabled = _this$props.disabled,
          invalid = _this$props.invalid,
          quiet = _this$props.quiet,
          className = _this$props.className,
          placeholder = _this$props.placeholder,
          renderTag = _this$props.renderTag,
          renderItem = _this$props.renderItem,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["getCompletions", "allowCreate", "disabled", "invalid", "quiet", "className", "placeholder", "renderTag", "renderItem"]);
      var _this$state = this.state,
          value = _this$state.value,
          tags = _this$state.tags,
          showMenu = _this$state.showMenu,
          isFocusVisible = _this$state.isFocusVisible;
      delete props.onChange;
      return _react["default"].createElement(_Autocomplete["default"], {
        className: (0, _classnames["default"])('react-spectrum-TagField', 'spectrum-Textfield', (0, _defineProperty2["default"])({
          'spectrum-Textfield--quiet': quiet,
          'react-spectrum-TagField--quiet': quiet,
          'is-disabled': disabled,
          'is-invalid': invalid
        }, _focusRing.FOCUS_RING_CLASSNAME, isFocusVisible), className),
        getCompletions: getCompletions,
        allowCreate: allowCreate,
        onSelect: this.onSelect,
        value: value,
        showMenu: showMenu,
        onChange: this.onTextfieldChange,
        onMenuToggle: this.onMenuToggle,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        renderItem: renderItem
      }, _react["default"].createElement(_TagList.TagList, {
        manageTabIndex: false,
        ref: function ref(tl) {
          return _this5.taglist = tl;
        },
        disabled: disabled,
        onClose: this.onRemove,
        values: !renderTag && tags.map(function (tag) {
          return tag.label || tag;
        }) || undefined,
        "aria-labelledby": props['aria-labelledby'],
        "aria-label": props['aria-label']
      }, renderTag && tags.map(function (tag, index) {
        return renderTag(tag, index);
      })), _react["default"].createElement(_Textfield["default"], (0, _extends2["default"])({
        ref: function ref(tf) {
          return _this5.textfield = tf;
        },
        className: "react-spectrum-TagField-input",
        onKeyDown: this.onKeyDown,
        autocompleteInput: true,
        disabled: disabled,
        placeholder: tags.length === 0 ? placeholder : ''
      }, props)));
    }
  }]);
  return TagField;
}(_react["default"].Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** Allow tag creation in tag field */
  allowCreate: _propTypes["default"].bool,

  /** Allow duplicate tags in tag field */
  allowDuplicates: _propTypes["default"].bool,

  /** Class to add to the tag field */
  className: _propTypes["default"].string,

  /** Placeholder text to display if there are no tags nor text entered */
  placeholder: _propTypes["default"].string,

  /** Whether the tag field is disabled */
  disabled: _propTypes["default"].bool,

  /** Function to retrieve autocomplete options */
  getCompletions: _propTypes["default"].func,

  /** Whether to disable the invalid icon and styling */
  invalid: _propTypes["default"].bool,

  /** Whether to use the quiet styling for the tag field */
  quiet: _propTypes["default"].bool,

  /** List of tags to display */
  value: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])),

  /**
   * A function called when a tag is added or removed.
   * It is passed an array of strings containing the new tag list.
   */
  onChange: _propTypes["default"].func,

  /**
   * A function that returns a wrapper component to render a list item label.
   * Useful in providing custom html to the rendered label.
   * Passed to the underlying Autocomplete component.
   */
  renderItem: _propTypes["default"].func,

  /**
   * A function that takes a tag object and returns a custom Tag component
   * If this prop is not specified, tags will render with default behavior
   */
  renderTag: _propTypes["default"].func
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  allowCreate: true,
  allowDuplicates: false,
  getCompletions: function getCompletions() {
    return [];
  }
}), _temp)) || _class) || _class;

exports["default"] = TagField;